<script setup lang="ts">

import Battery from "@/modules/Presentation/Icons/Battery.vue";
import Brakes from "@/modules/Presentation/Icons/Brakes.vue";
import KeyFob from "@/modules/Presentation/Icons/KeyFob.vue";
import Puncture from "@/modules/Presentation/Icons/Puncture.vue";
import Tyres from "@/modules/Presentation/Icons/Tyres.vue";
import WiperBlades from "@/modules/Presentation/Icons/WiperBlades.vue";

</script> 

<template>

    <div class="flex flex-col min-h-full items-center justify-center w-full h-full gap-12 tracking-wider">
        
        <Image src="/Carnex.png" class="w-4/5 md:w-3/5 lg:w-1/5" />

        <h1 class="text-2xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl font-semibold uppercase text-center">
            Wear &amp; Tear Protection
        </h1>

        <div class="grid grid-cols-6 gap-6 xl:gap-8 2xl:gap-12 mb-6 text-sm xl:text-base">
            <div class="flex flex-col justify-center items-center gap-2">
                <WiperBlades class="!text-4xl !text-[#2b85be]"/>
                <p class="text-center font-semibold uppercase">Wiper Blade<br/>Replacement</p>
            </div>
            <div class="flex flex-col justify-center items-center gap-2">
                <Battery class="!text-4xl !text-[#2b85be]"/>
                <p class="text-center font-semibold uppercase">12V Battery<br/>Replacement</p>
            </div>
            <div class="flex flex-col justify-center items-center gap-2">
                <Brakes class="!text-4xl !text-[#2b85be]"/>
                <p class="text-center font-semibold uppercase">Brake<br/>Safety</p>
            </div>
            <div class="flex flex-col justify-center items-center gap-2">
                <KeyFob class="!text-4xl !text-[#2b85be]"/>
                <p class="text-center font-semibold uppercase">Key Fob<br/>Repair</p>
            </div>
            <div class="flex flex-col justify-center items-center gap-2">
                <Tyres class="!text-4xl !text-[#2b85be]"/>
                <p class="text-center font-semibold uppercase">Tyre<br/>Repair</p>
            </div>
            <div class="flex flex-col justify-center items-center gap-2">
                <Puncture class="!text-4xl !text-[#2b85be]"/>
                <p class="text-center font-semibold uppercase">Tyre<br/>Replacement</p>
            </div>
        </div>

        <h1 class="text-2xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl font-semibold uppercase text-center -mt-6">
            Revenue Today <span class="text-[#2b85be]">More Revenue Tomorrow</span>
        </h1>


    </div>

</template>